"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePreviousEmployerData = exports.previousEmployerFormRules = exports.previousEmployerSchema = void 0;
const converters_1 = require("../../converters");
const income_1 = require("./income");
exports.previousEmployerSchema = {
    fields: {
        ...income_1.incomeSchema.fields,
    },
    messages: {
        ...income_1.incomeSchema.messages,
        institution_name: {
            maxLength: 'Previous Employer must be 200 characters or less',
        },
    },
};
// 🚀 Pre-computed validations for performance
exports.previousEmployerFormRules = (0, converters_1.toReactHookForm)(exports.previousEmployerSchema, income_1.incomeFieldMapping);
exports.validatePreviousEmployerData = (0, converters_1.createValidator)(exports.previousEmployerSchema);
